import { graphql } from 'gatsby';
import { useIsHemX } from 'gatsby-theme-hem-store/src/hooks/useIsHemX';
import { Button } from 'hem-ui';
import get from 'lodash/get';
import isString from 'lodash/isString';
import React from 'react';

import { fixSlug } from './RichText';
import { root } from './RichTextLinkGroup.module.scss';

const RichTextLinkGroup: React.FC<{
  node: { data: { target: Queries.RichTextLinkGroupFragment } };
}> = ({ node }) => {
  const entry = get(node, 'data.target');
  const { isHemX } = useIsHemX();

  if (!entry) {
    console.warn('[RichTextLinkGroup] Entry not rendered', { node });
    return null;
  }

  return (
    <div className={root}>
      <ul>
        {React.Children.toArray(
          entry.links.map((link) => {
            let slug;
            let title;
            switch (link.__typename) {
              case 'ContentfulPage':
                slug = fixSlug(link.slug);
                title = link.meta.title;
                break;
              case 'ContentfulLink':
                slug = fixSlug(link.slug || link.entry?.slug);
                title = link.title;
                break;
              default:
                slug = fixSlug(link.slug);
                title = link.title;
                break;
            }

            if (!slug || !title) {
              console.warn('[RichTextLinkGroup] Link not rendered', {
                node,
                link,
              });

              return null;
            }

            // check if slug is /hem-x or /en-eu/hem-x, or /en-us/hem-x, or /en-ca/hem-x
            // then we don't want to show the "Curated by" text
            const isBaseHemXSlug = isString(slug)
              ? slug.replace(/^\/([a-z]{2}-[a-z]{2})/g, '') === '/hem-x'
              : false;

            return (
              <li>
                <Button to={slug} size="small">
                  {isHemX ? (isBaseHemXSlug ? null : 'Curated by ') : null}
                  {title}
                </Button>
              </li>
            );
          }),
        )}
      </ul>
    </div>
  );
};

export default RichTextLinkGroup;

export const query = graphql`
  fragment RichTextLinkGroup on ContentfulComponentLinkGroup {
    __typename
    contentful_id
    links {
      __typename
      ... on ContentfulLink {
        ...Link
      }
      ... on ContentfulPageDepartment {
        slug
        title
      }
      ... on ContentfulPageCategory {
        slug
        title
      }
      ... on ContentfulPageSubcategory {
        slug
        title
      }
      ... on ContentfulPage {
        slug
        meta: metaContent {
          title: metaTitle
        }
      }
    }
  }
`;
